import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';

import { StyledBox } from './styles/Box';
import { StyledTypography } from './styles/Typography';

function SectionLearnMore({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <StyledBox
      tag="section"
    >
      <Grid row>
        <Grid
          col={{ xs: 12, lg: 9, xl: 6 }}
          offset={{ lg: 1 }}
        >
          <Typography
            variant="supertitle"
            gutterBottom={1}
            color="white"
            intlKey={`cms.pixPage.pixCardsArea[${index}].title`}
            whiteSpace="pre-line"
          />
          <StyledTypography
            variant="subtitle"
            gutterBottom={1.5}
            color="white"
            intlKey={`cms.pixPage.pixCardsArea[${index}].description`}
          />
          <Link
            variant="action"
            color="white"
            href={formatMessage({ id: `cms.pixPage.pixCardsArea[${index}].ctaLink` })}
            intlKey={`cms.pixPage.pixCardsArea[${index}].ctaText`}
          />
        </Grid>
      </Grid>
    </StyledBox>
  );
}

SectionLearnMore.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionLearnMore);
